import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Calendar } from 'primereact/calendar';
import { Tag } from 'primereact/tag';
import axios from 'axios';
import moment from 'moment';
import '../custom.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const SalesReport = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [grandTotals, setGrandTotals] = useState({
    current: 0,
    previous: 0,
    total: 0
  });

  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);
 
  const [ubranch, setUbranch] = useState(null);
  const [userid, setUserid] = useState(null);
  const [branchid, setBranchid] = useState(null);
  const [clientid, setClientid] = useState(null);

  useEffect(() => {
      const storedBranch = localStorage.getItem('branch');
      const storedUserid = localStorage.getItem('userid');
      const storedbranchid = localStorage.getItem('branchid');
      const storedclientid = localStorage.getItem('clientid');

      if (storedBranch && storedclientid) {
          setUbranch(storedBranch);
          setUserid(storedUserid);
          setBranchid(storedbranchid);
          setClientid(storedclientid);

          axios
              .get(`https://treatway.co.in/Counter-Backend/SalesApi/get_branches?client_id=${storedclientid}`)
              .then((res) => setBranches(res.data))
              .catch((err) => console.error('Error fetching branches:', err));
      }
  }, []);

  useEffect(() => {
      if (selectedBranch) {
          axios
              .get(`https://treatway.co.in/Counter-Backend/SalesApi/get_users_by_branch`, {
                  params: { branch_id: selectedBranch.branch_id }
              })
              .then((res) => setUsers(res.data))
              .catch((err) => console.error('Error fetching users:', err));
      } else {
          setUsers([]);
          setSelectedUser(null);
      }
  }, [selectedBranch]);

  useEffect(() => {
      if (fromDate && toDate && selectedBranch) {
          fetchSalesReport();
      }
  }, [fromDate, toDate, selectedBranch, selectedUser]);

  const fetchSalesReport = () => {
      setLoading(true);
      setHasSearched(true);

      const from = moment(fromDate).format('YYYY-MM-DD');
      const to = moment(toDate).format('YYYY-MM-DD');

      axios
          .get(`https://treatway.co.in/Counter-Backend/SalesApi/get_payment_mode_sales_report`, {
              params: {
                  client_id: clientid,
                  branch_id: selectedBranch?.branch_id,
                  user_id: selectedUser?.userId || '',
                  from_date: from,
                  to_date: to
              }
          })
          .then((res) => {
              const current = res.data.current || [];
              const previous = res.data.previous || [];

              const merged = {};

              current.forEach((item) => {
                  merged[item.final_mop] = {
                      final_mop: item.final_mop,
                      current_day_total: parseFloat(item.current_day_total),
                      prev_day_total: 0
                  };
              });

              previous.forEach((item) => {
                  if (merged[item.final_mop]) {
                      merged[item.final_mop].prev_day_total = parseFloat(item.prev_day_total);
                  } else {
                      merged[item.final_mop] = {
                          final_mop: item.final_mop,
                          current_day_total: 0,
                          prev_day_total: parseFloat(item.prev_day_total)
                      };
                  }
              });

              const finalReport = Object.values(merged).map((item) => ({
                  ...item,
                  total: item.current_day_total + item.prev_day_total
              }));

              const totalCurrent = finalReport.reduce((sum, item) => sum + item.current_day_total, 0);
              const totalPrevious = finalReport.reduce((sum, item) => sum + item.prev_day_total, 0);
              const totalCombined = finalReport.reduce((sum, item) => sum + item.total, 0);

              setGrandTotals({
                  current: totalCurrent,
                  previous: totalPrevious,
                  total: totalCombined
              });

              setReportData(finalReport);
          })
          .catch((err) => console.error('Error fetching report:', err))
          .finally(() => setLoading(false));
  };


const footerGroup = (
  <ColumnGroup>
    <Row>
      <Column footer="Grand Total" colSpan={1} />
      <Column footer={grandTotals.current.toFixed(2)} style={{ textAlign: 'center' }} />
      <Column footer={grandTotals.previous.toFixed(2)} style={{ textAlign: 'center' }} />
      <Column footer={grandTotals.total.toFixed(0)} style={{ textAlign: 'center' }} />
    </Row>
  </ColumnGroup>
);



  return (
    <>
    <h4 className="text-xl font-bold mb-4">Sales Report</h4>
    <div className='card'>
      <div className="flex flex-wrap gap-4 mt-3 align-items-end">
        <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
          <label htmlFor="fromDate" className="mb-1 font-medium">From Date</label>
            <Calendar 
                id="fromDate" 
                value={fromDate} 
                onChange={(e) => {
                    const newFromDate = e.value;
                    setFromDate(newFromDate);
    
                    // If toDate is empty or before new fromDate, set it to new fromDate
                    if (!toDate || newFromDate > toDate) {
                        setToDate(newFromDate);
                    }
                }} 
                dateFormat="dd-mm-yy" 
                showIcon 
                placeholder="Select From Date" 
              //  maxDate={toDate} // Prevents selecting a fromDate after already-set toDate
            />
        </div>

        <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
          <label htmlFor="toDate" className="mb-1 font-medium">To Date</label>
          <Calendar 
              id="toDate" 
              value={toDate} 
              onChange={(e) => setToDate(e.value)} 
              dateFormat="dd-mm-yy" 
              showIcon 
              placeholder="Select To Date" 
              minDate={fromDate} // Prevents selecting a toDate before fromDate
          />
        </div>

        <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
          <label htmlFor="branch" className="mb-1 font-medium">Select Branch</label>
          <Dropdown id="branch" value={selectedBranch} options={branches} onChange={(e) => setSelectedBranch(e.value)} optionLabel="branch_name" placeholder="Select Branch" className="w-full" filter />
        </div>

        <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
          <label htmlFor="user" className="mb-1 font-medium">Select User</label>
          <Dropdown 
            id="user" 
            value={selectedUser} 
            options={users} 
            onChange={(e) => setSelectedUser(e.value)} 
            optionLabel="username"
            placeholder="Select User" 
            className="w-full" 
            filter 
          />
        </div>
      </div>
      </div>
      
    <div className='card'>
      {loading ? (
        <div className="text-center p-4">Loading...</div>
      ) : reportData.length > 0 ? (
        <DataTable value={reportData} showGridlines tableStyle={{ minWidth: '50rem' }} className="p-datatable-sm" footerColumnGroup={footerGroup}>
          <Column field="final_mop" header="Payment Mode" />
          <Column field="current_day_total" header="Current Day" body={(row) => row.current_day_total.toFixed(2)} style={{ textAlign: 'center' }} />
          <Column field="prev_day_total" header="Previous Day" body={(row) => row.prev_day_total.toFixed(2)} style={{ textAlign: 'center' }} />
          <Column field="total" header="Total" body={(row) => row.total.toFixed(0)} style={{ textAlign: 'center' }} />
        </DataTable>
      ) : (
        <div className="text-center p-4 text-gray-500">
          {hasSearched ? "No records found for the selected values" : "No records"}
        </div>
      )}
    </div>

    </>
  );
};

export default SalesReport;
